import SigninInitialState from './Login/InitialState';
import GlobalLoadingInitialState from './GlobalLoading/InitialState';
import UiInitialState from './Ui/InitialState';
import autenticationModalInitialState from './AuthenticationModal/InitialState';

const AppInitialState = {
  signin: SigninInitialState,
  globalLoading:GlobalLoadingInitialState,
  ui:UiInitialState,
  authenticationModal:autenticationModalInitialState

}

export default AppInitialState